export default "__VITE_ASSET__B6hlXNwT__"